module.exports = __webpack_public_path__ + "static/media/星球转动仪.2e9a5fee.png";